import React from "react";

import { FieldGroup } from "../components"
import { AjaxForm } from "./index.jsx"

const ChangePasswordForm = ({ user, successMessage, token }) => {
    const formProps = {
        method: "put",
        url: `/api/users/${user?.id}/password`,
        token,
        fields: ['password', 'password2'],
        submitLabel: "Set New Password",
        successTitle: "Password successfully changed",
        successMessage: successMessage
    }

    return (
        <AjaxForm {...formProps}>
            <FieldGroup
                placeholder="New Password"
                type="password"
                name="password"
            />

            <FieldGroup
                placeholder="Confirm Password"
                type="password"
                name="password2"
            />
        </AjaxForm>
    )
};

export default ChangePasswordForm;
